import React, { useEffect, useState } from "react";
import { Button, Card, Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsRandomizationSchemaServices } from "../../../APIServices/EIWRS/eiwrsRandomizationSchemaServices";
import { studyFactorServices } from "../../../APIServices/CTMS/studyFactorServices";

const AddNewStudyRandomizationSchema = ({ treatmentList, getEIWRSRandomizationSchemaData }) => {
  let { studyId } = useParams();
  const [factors, setFactors] = useState([]);
  const [schemaName, setSchemaName] = useState("");
  const [randomizationType, setRandomizationType] = useState("");
  const [allocationRatio, setAllocationRatio] = useState({});
  const [description, setDescription] = useState("");
  const [level, setLevel] = useState("");
  const [blinded, setBlinded] = useState("");
  const [numberOfBlock, setNumberOfBlock] = useState(0);
  const [mainBlockSize, setMainBlockSize] = useState(0);
  const [numberOfSubject, setNumberOfSubject] = useState(0);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [isFloatResult, setIsFloatResult] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const addNewEIWRSRandomizationSchema = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.schemaName = schemaName;
    userData.randomizationType = randomizationType;
    if (randomizationType != "assignBased") {
      if (randomizationType === "simple") {
        userData.numberOfSubject = numberOfSubject;
      }
      if (randomizationType === "block" || randomizationType === "stratified") {
        userData.numberOfBlock = numberOfBlock;
      }
      userData.allocationRatio = allocationRatio;
      userData.blockSize = mainBlockSize;
    }
    userData.description = description;
    userData.blinded = blinded;
    userData.level = level;
    let data = await eiwrsRandomizationSchemaServices.addNewEIWRSRandomizationSchema(
      userData
    );
    if (data?.statusCode === 200) {
      setSchemaName("");
      setRandomizationType("");
      setAllocationRatio({});
      setNumberOfBlock(0)
      setMainBlockSize(0)
      setNumberOfSubject(0)
      setDescription("");
      setBlinded("");
      setLevel("");
      getEIWRSRandomizationSchemaData()
    }
    setButtonLoader(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAllocationRatio((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    setSchemaName("");
    setRandomizationType("");
    setAllocationRatio([]);
    setDescription("");
    setNumberOfBlock(0)
    setMainBlockSize(0)
    setNumberOfSubject(0)
    setBlinded("");
    setLevel("");
  }, []);

  useEffect(() => {
    const totalRatio = Object.values(allocationRatio)
      .reduce((sum, value) => sum + Number(value), 0);
    setMainBlockSize(totalRatio * Number(numberOfBlock))
  }, [allocationRatio, numberOfBlock]);

  useEffect(() => {
    if (randomizationType === "simple") {
      const totalRatio = Object.values(allocationRatio)
        .reduce((sum, value) => sum + Number(value), 0);
      setIsFloatResult(!Number.isInteger(Number(numberOfSubject) / totalRatio));
    } else {
      setIsFloatResult(false)
    }
  }, [randomizationType, allocationRatio, numberOfSubject]);

  return (
    <div className="p-2">
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          SchemaName{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setSchemaName(e.target.value)}
          value={schemaName}
          className="br3"
          placeholder="Enter SchemaName"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Randomization Level{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          value={level}
          onChange={(e) => setLevel(e.target.value)}
          className="br3"
        >
          <option value="">Select</option>
          <option value="studyLevel">Study Level</option>
          <option value="siteLevel">Site Level</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Randomization Type{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          value={randomizationType}
          onChange={(e) => setRandomizationType(e.target.value)}
          className="br3"
        >
          <option value="">Select Type</option>
          <option value="simple">Simple</option>
          <option value="block">Block</option>
          <option value="stratified">Stratified Block</option>
          <option value="assignBased">Assign Based Randomization</option>
          {/* <option value="permuted">Permuted Block</option>
          <option value="variable">Variable Block</option>
          <option value="minimization">Minimization Block</option>
          <option value="unequal">Unequal Allocation</option>
          <option value="doseesc">Dose-Escalation</option> */}
        </Form.Select>
      </Form.Group>
      {randomizationType != "assignBased" &&
        <>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Treatment Ratio:
            </Form.Label>
            {treatmentList?.map((item, index) => (
              <Form.Group key={index} className="mb-1">
                <Form.Label className="mb-1 fw-bold">
                  {item?.row?.TRT}{" "}
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                </Form.Label>
                <Form.Control
                  required
                  type="number"
                  name={item?.treatmentId}
                  disabled={StudyMode !== "DBP Mode"}
                  value={allocationRatio[item?.treatmentId] || ""}
                  placeholder="Enter Treatment Ratio"
                  onChange={handleChange}
                />
              </Form.Group>
            ))}
          </Form.Group>
          {(randomizationType === "block" || randomizationType === "stratified") &&
            <>
              <Form.Group className="mb-1">
                <Form.Label className="fw-bold mb-1">
                  Block Size Calculation{" "}
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                </Form.Label>
                <Form.Label className="mb-1 d-block">Block Size Calculator</Form.Label>
                <Form.Control
                  type="number"
                  value={numberOfBlock}
                  onChange={(e) => setNumberOfBlock(e.target.value)}
                  placeholder="Enter Number of Block"
                  className="br3 mb-2"
                />
                <Form.Label className="mb-1">Block Size</Form.Label>
                <Form.Control
                  type="number"
                  value={mainBlockSize}
                  disabled
                  placeholder="Calculated Block Size"
                  className="br3"
                />
              </Form.Group>
            </>
          }
          {randomizationType === "simple" &&
            <Form.Group className="mb-1">
              <Form.Label className="fw-bold mb-1">
                No of Subject{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Control
                type="number"
                value={numberOfSubject}
                onChange={(e) => setNumberOfSubject(e.target.value)}
                placeholder="Enter No of Subject"
                className={`br3 ${isFloatResult ? "border-danger" : ""}`}
                style={{ fontSize: "13px" }}
              />
            </Form.Group>
          }
        </>
      }
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Description
        </Form.Label>
        <Form.Control
          as="textarea"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={2}
          placeholder="Enter description"
          className="br3"
          style={{ fontSize: "13px", resize: "vertical" }}
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Blinded{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          value={blinded}
          onChange={(e) => setBlinded(e.target.value)}
          className="br3"
        >
          <option value="">Select</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </Form.Select>
      </Form.Group>
      <div className="text-end">
        <button
          disabled={
            randomizationType === "assignBased" ?
              (!level || !schemaName || !randomizationType || !blinded || buttonLoader)
              :
              (isFloatResult || !level || (randomizationType === "simple" ? !numberOfSubject : !numberOfBlock) || !schemaName || !randomizationType || allocationRatio?.length === 0 || !blinded || buttonLoader)
          }
          onClick={addNewEIWRSRandomizationSchema}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Adding...
            </div>
          ) : (
            "Add Schema"
          )}
        </button>
      </div>
    </div>
  );
};

export default AddNewStudyRandomizationSchema;
